module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n            " + _vm._s(_vm.year) + " © Deveo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "logout"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("\n                Log out\n                "), _c('i', {
    staticClass: "fad fa-sign-out fa-fw"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebecd11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
// module id = 288
// module chunks = 1